import { FormData, ExpandedFormData } from "../../data/models";
import axios from "axios";
import { toast } from "react-toastify";
import { COMMERCIAL_MODELS } from "../../data/models/VehicleModels";


const getBrandFromModel = (model?: string) =>
  model && COMMERCIAL_MODELS.has(model.trim()) ? "FIATPROFESSIONAL" : "FIAT";

// [SECURITY]
const MAX_BYTES = 50 * 1024;

// [SECURITY]
const toastMsgForStatus = (status?: number) => {
  switch (status) {
    case 401:
      return "Molimo prijavite se kako biste nastavili.";
    case 403:
      return "Nemate ovlasti za ovu radnju.";
    case 413:
      return "Poruka je prevelika. Skratite sadržaj i pokušajte ponovno.";
    case 400:
    case 422:
      return "Neispravni podaci u obrascu. Provjerite unesena polja.";
    case 429:
      return "Previše pokušaja. Pokušajte kasnije.";
    default:
      return "Došlo je do pogreške pri slanju upita.";
  }
};

export const sendEmail = async ({
  formData,
  mode,
}: {
  formData: FormData | ExpandedFormData;
  mode?: string;
}) => {
  const formattedData = formatDataForBackend(formData);

  // [SECURITY] CLIENT-SIDE GUARD: izmjeri veličinu JSON-a i zaustavi prevelike requeste
  const json = JSON.stringify(formattedData);
  const byteSize = new TextEncoder().encode(json).length;
  if (byteSize > MAX_BYTES) {
    toast.error(
      `Poruka je prevelika (${byteSize} B > ${MAX_BYTES} B). Skratite sadržaj i pokušajte ponovno.`,
    );
    return;
  }

  const model =
    "vehicle" in formData && formData.vehicle
      ? formData.vehicle["Model vozila"]
      : undefined;

  const BRAND = getBrandFromModel(model);

  if (mode === "Ponuda") {
    try {
      const response = await axios.post(
        `https://findmyclues-api.azurewebsites.net/api/v1/vehicles/offer/${BRAND}/`,
        formattedData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      toast.success("Upit uspjesno poslan!");
      toast.success(
        "Hvala Vam na upitu. Uskoro će vas kontaktirati FIAT prodajni savjetnik.",
      );
      // console.log("Response from server:", response.data);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const status = error.response?.status;
        toast.error(toastMsgForStatus(status));
      } else {
        toast.error("Neočekivana pogreška pri slanju upita.");
      }
    }
  } else if (mode === "Testna vožnja") {
    try {
      const response = await axios.post(
        `https://findmyclues-api.azurewebsites.net/api/v1/vehicles/test/${BRAND}/`,
        formattedData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      toast.success("Upit uspjesno poslan!");
      toast.success(
        "Hvala Vam na upitu. Uskoro će vas kontaktirati FIAT prodajni savjetnik.",
      );
      // console.log("Response from server:", response.data);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const status = error.response?.status;
        toast.error(toastMsgForStatus(status));
      } else {
        toast.error("Neočekivana pogreška pri slanju upita.");
      }
    }
  } else {
    //Mode === "newsletter"
    try {
      const response = await axios.post(
        `https://findmyclues-api.azurewebsites.net/api/v1/vehicles/newsletter/${BRAND}/`,
        formattedData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      toast.success("Uspješno ste prijavljeni na naš newsletter!");
      toast.success("Hvala Vam na prijavi! - Tim FIAT");
      // console.log("Response from server:", response.data);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const status = error.response?.status;
        toast.error(toastMsgForStatus(status));
      } else {
        toast.error("Neočekivana pogreška pri slanju prijave.");
      }
    }
  }
};

export const formatDataForBackend = (formData: FormData | ExpandedFormData) => {
  const formattedData: Record<string, any> = {
    first_name: formData.general["Ime"],
    last_name: formData.general["Prezime"],
    email: formData.general["Email adresa"],

    consent: formData.conditions.includes("consent"),
  };

  if (
    "vehicle" in formData &&
    formData.vehicle &&
    Object.keys(formData.vehicle).length > 0
  ) {
    formattedData.phone = formData.general["Telefonski broj"];
    formattedData.location = formData.general["Grad"];
    formattedData.postalcode = formData.general["Poštanski broj"];

    formattedData.car_info = {
      vin: formData.vehicle["Broj šasije"] || undefined,
      model: formData.vehicle["Model vozila"] || undefined,
    };
    formattedData.car_dealer = formData.vehicle["Auto centar"];
  }

  return formattedData;
};
